import React from 'react'
import fetch from './utils/fetch'
import { Service, EmptyService } from './pages'
import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import { Provider as FaencyProvider, Box, Loading } from '@containous/faency'
import { QueryParamProvider } from 'use-query-params'
import { SWRConfig } from 'swr'
import { NotFound, Page } from './components'

const PageLoader: React.FC = () => (
  <Page>
    <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0 }}>
      <Loading />
    </Box>
  </Page>
)

export const Routes: React.FC = () => {
  return (
    <React.Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path="/:name" component={Service} />
        <Route exact path="/" component={EmptyService} />
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </React.Suspense>
  )
}

const App: React.FC = () => (
  <FaencyProvider>
    <SWRConfig
      value={{
        revalidateOnFocus: true,
        fetcher: fetch,
      }}
    >
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Routes />
        </QueryParamProvider>
      </Router>
    </SWRConfig>
  </FaencyProvider>
)

export default App
